import {FC} from 'react';

import {Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {useAppSelector} from 'hooks';
import {formatPriceWithCurrency} from 'utils';

import {StyledBasketDangerBanner} from '../styled';

export const BasketMinimumOrderBanner: FC = () => {
  const {t} = useTranslation();
  const {basket} = useAppSelector((state) => state?.basket);

  if (!basket || !basket?.prices || !basket?.basketItems.length) {
    return null;
  }

  const remainingMinimumSpend = basket.prices.minimumBasket - basket.prices.totalDisplayPricePostVoucher;
  if (remainingMinimumSpend <= 0) {
    return null;
  }

  const message: string | undefined = t('message.remainingMinimumSpendV3', {
    remainingMinimumSpend: formatPriceWithCurrency(remainingMinimumSpend || 0, basket.priceUnit)
  });

  return (
    <StyledBasketDangerBanner>
      <Typography component={'p'} variant="body2" dangerouslySetInnerHTML={{__html: message}} color={'#BA1A1A'} />
    </StyledBasketDangerBanner>
  );
};

BasketMinimumOrderBanner.displayName = 'BasketMinimumOrderBanner';
